import type { ReactNode } from "react"
import { cn } from "~/lib/utils"
import { OrbitLogo } from "../icons/logos"

export function FullScreen({
	title,
	message,
	centerContent,
	bottomContent,
	contentClassName
}: {
	title: string
	message?: string | ReactNode
	centerContent?: ReactNode
	bottomContent?: ReactNode
	contentClassName?: string
}) {
	return (
		<div className="orbit-full-screen flex h-screen w-screen flex-col bg-orbit-gradient">
			<div
				className={cn(
					"flex flex-1 flex-col gap-4 items-center justify-center w-lg max-w-[calc(100vw-2rem)] text-center font-semibold self-center",
					contentClassName
				)}
			>
				<header className="flex flex-col gap-2 items-center justify-center">
					<OrbitLogo />
					<h1 className="text-text-main text-xl">{title}</h1>
				</header>
				{centerContent ? centerContent : null}
				{message ?? (
					<main className="text-text-small text-sm font-semibold">
						{message}
					</main>
				)}
				{bottomContent ?? null}
			</div>
		</div>
	)
}
